/**
 * Common utility for resolving locale
 */

import { transformLanguage } from '../localization/utils'

interface LocaleOptions {
  includeLocalStorage?: boolean
  defaultLocale?: string
}

/**
 * Resolves the appropriate locale based on store state and fallbacks
 * @param store - Vuex store instance
 * @param options - Configuration options
 * @returns Resolved locale string (normalized to hyphen format, e.g., 'en-US')
 */
export function resolveLocale(store: any, options: LocaleOptions = {}): string {
  const { includeLocalStorage = true, defaultLocale = 'en-US' } = options

  // Priority order: User -> Location -> LocalStorage -> Default
  const userSpecificLanguage = store?.state?.user?.user?.platformLanguage
  const locationSpecificLanguage = store?.state?.locations?.currentLocation?.locale_settings?.platform
  const localStorageLocale = includeLocalStorage ? localStorage.getItem('locale') : null

  const locale = userSpecificLanguage || locationSpecificLanguage || localStorageLocale || defaultLocale

  // Normalize to hyphen format (e.g., en_US -> en-US) for consistency
  return transformLanguage(locale)
}
